import { logWithPrefix } from "@/plugins/logging";
import mapping from "@/mapping";
import _ from "lodash";
import { Base64 } from "js-base64";
import Vue from "vue";
import { http } from "@/plugins/axios";
import router from "@/router";
import dniPattern from "@/utils/dniPattern";
import i18n from "@/plugins/i18n";
import store from "@/store";
import ids from "@/ids";
import defaultSettings from "@/settings";
const log = logWithPrefix("[plugin/utils.js]");

// const ssidPattern = /^[a-z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\] ^_`{|}~-\s]+$/
// // Not support "&'()*;<>
// const ssid60GPattern = /^[a-z0-9!#$%+,.\\/:=?@\\[\] ^_`{|}~-\s]+$/

const utils = {};

utils.htmlEncode = (value) => {
  if (!value) {
    log("htmlEncode", value);
    return "";
  }
  return value
    .replace(/&/g, "&#38;")
    .replace(/ /g, "&nbsp;")
    .replace(/</g, "&lt;")
    .replace("/>/g", "&gt;");
};
utils.getOptions = (page, name) => {
  if (!mapping[page]) {
    log("getOptions", `Cannot find mapping.${page}`);
    return [];
  }
  if (!mapping[page][name]) {
    log("getOptions", `Cannot find ${name} in mapping.${page}`);
    return [];
  }
  return mapping[page][name];
};
utils.transferConfig2Value = (page, name, config) => {
  if (!mapping[page]) {
    log(`Cannot find ${page} in mapping`);
    return config;
  }
  if (!mapping[page][name]) {
    log(`Cannot find ${name} in mapping[${page}]`);
    return config;
  }
  if (typeof mapping[page][name] == "string") {
    return config;
  }
  const find = mapping[page][name].filter((o) => o.config === config);
  if (find && find.length) {
    if (find.length > 1) {
      log(`Found dumplicate config ${config} in mapping.${name}`);
    }
    return find[0].value;
  }
  log(`Cannot find config:i18n.t("{config}" in mapping.${name}, using first one`);
  return mapping[page][name][0].value;
};
utils.transferValue2Config = (page, name, value) => {
  if (!mapping[page]) {
    log(`Cannot find ${page} in mapping`);
    return value;
  }
  if (!mapping[page][name]) {
    log(`Cannot find ${name} in mapping[${page}]`);
    return value;
  }
  if (mapping[page][name] == "dniEncrypt" || mapping[page][name] == "pwdEncrypt") {
    return utils.dniEncrypt(value);
  }
  const find = mapping[page][name].filter((o) => o.value === value);
  if (find && find.length) {
    if (find.length > 1) {
      log(`Found dumplicate value ${value} in mapping.${name}`);
    }
    return find[0].config;
  }
  return value;
};
utils.transferConfig2Img = (page, name, config) => {
  if (!mapping[page]) {
    log(`Cannot find ${page} in mapping`);
    return null;
  }
  if (!mapping[page][name]) {
    log(`Cannot find ${name} in mapping[${page}]`);
    return null;
  }
  const find = mapping[page][name].filter((o) => o.config === config);
  if (find && find.length) {
    if (find.length > 1) {
      log(`Found dumplicate config ${config} in mapping.${name}`);
    }
    return find[0].img;
  }
  log(`Cannot find config:i18n.t("{config}" in mapping.${name}, using first one`);
  return mapping[page][name][0].img;
};
utils.getChildObject = (keyPath, obj) => {
  const keyArray = keyPath.split(".");
  let childObj = obj;
  let parentObj = obj;
  for (let i = 0; i < keyArray.length; i++) {
    if (childObj[keyArray[i]]) {
      parentObj = childObj;
      childObj = childObj[keyArray[i]];
    } else {
      return childObj;
    }
  }
  return { target: parentObj, value: childObj };
};
utils.transferSettings = (page, settings) => {
  const m = mapping[page];
  const result = Object.assign({}, settings);
  if (!m) {
    return result;
  }
  const keys = Object.keys(m);
  for (let i = 0; i < keys.length; i++) {
    const value = _.result(result, keys[i], "");
    const newValue = utils.transferConfig2Value(page, keys[i], value);
    _.updateWith(result, keys[i], _.constant(newValue));
  }
  log("transferSettings", page, result);
  return result;
};
utils.transferValues = (page, pageSettings) => {
  const m = mapping[page];
  const result = Object.assign({}, pageSettings);
  if (!m) {
    return result;
  }
  const keys = Object.keys(m);
  for (let i = 0; i < keys.length; i++) {
    const value = _.result(result, keys[i], null);
    if (mapping[page] && mapping[page][keys[i]] == "pwdEncrypt") {
      delete result[keys[i] + "_empty"];
      const isChanged = result[keys[i] + "_changed"];
      log(isChanged);
      delete result[keys[i] + "_changed"];
      if (!isChanged) {
        delete result[keys[i]];
        continue;
      }
    }
    const newValue = utils.transferValue2Config(page, keys[i], value);
    _.updateWith(result, keys[i], _.constant(newValue));
  }
  return result;
};

utils.checkValidation = (patternTag, value, allowEmpty) => {
  /**
   * @param {String} patternTag : tag in dniPattern, you can find it in utils/dniPattern.js
   * @param {String} value
   * @param {Boolean} allowEmpty
   */
  if (typeof value === "undefined") {
    return true;
  }
  if (!dniPattern[patternTag]) {
    log(`Cannot find dniPattern.${patternTag}`);
    return true;
  }
  log("checkValidation", patternTag, value, allowEmpty);
  if (allowEmpty && value === "") {
    return true;
  }
  return dniPattern[patternTag].test(value);
};
utils.alertBox = (msg) => {
  alert(msg);
};
utils.confirmBox = (msg) => {
  return confirm(msg);
};
utils.getElementById = (id, msg) => {
  document.getElementById(id).innerHTML = msg;
};

utils.checkIp = (ip) => {
  /**
   * Check the validation for WAN IP
   *  * Bellow is invalid
   *  * ip1 > 223
   *  * ip1 == 0
   *  * 0.0.0.0, 255.255.255.255
   *  * 127.*.*.*
   * @param {String} ip
   */
  if (!utils.checkValidation("ipv4", ip, false)) {
    return false;
  }
  if (ip === "0.0.0.0" || ip === "255.255.255.255") {
    return false;
  }
  const ip1 = parseInt(ip.split(".")[0], 10);
  if (ip1 === 0 || ip1 === 127 || ip1 > 223) {
    return false;
  }
  return true;
};

utils.checkGateway = (ip) => {
  /**
   * Check the validation for WAN Gateway
   *  * Bellow is invalid
   *  * ip1 > 223
   *  * ip1 == 0
   *  * 0.0.0.0, 255.255.255.255, 127.0.0.1
   * @param {String} ip
   */
  if (!utils.checkValidation("ipv4", ip, false)) {
    return false;
  }
  if (ip === "0.0.0.0" || ip === "255.255.255.255" || ip === "127.0.0.1") {
    return false;
  }
  const ip1 = parseInt(ip.split(".")[0], 10);
  if (ip1 === 0 || ip1 > 223) {
    return false;
  }
  return true;
};

utils.getSubnet = (ip, mask) => {
  /**
   * Get Subnet according to `ip` and `mask`
   * @param {String} ip
   * @param {String} mask
   */
  if (!utils.checkValidation("ipv4", ip, false)) {
    return "";
  }
  if (!utils.checkValidation("ipv4", mask, false)) {
    return "";
  }
  const ipArr = ip.split(".");
  const maskArr = mask.split(".");
  const res = [];
  for (let i = 0; i < ipArr.length; i++) {
    res[i] = parseInt(ipArr[i], 10) & parseInt(maskArr[i], 10);
  }
  return res.join(".");
};
utils.isSameSubnet = (ip1, mask1, ip2, mask2) => {
  const subnet1 = utils.getSubnet(ip1, mask1);
  const subnet2 = utils.getSubnet(ip2, mask2);
  return subnet1 === subnet2 && subnet1 !== "";
};

utils.getBroadcase = (ip, mask) => {
  /**
   *
   * @param {String} ip
   * @param {String} mask
   */
  if (utils.checkValidation("ipv4", ip, false)) {
    return "";
  }
  if (utils.checkValidation("ipv4", mask, false)) {
    return "";
  }
  const ipArr = ip.split(".");
  const maskArr = mask.split(".");
  const res = [];
  for (let i = 0; i < ipArr.length; i++) {
    res[i] = parseInt(ipArr[i], 10) | parseInt(maskArr[i], 10);
  }
  return res.join(".");
};

utils.isSubOrBroad = (beCheckIp, ip, mask) => {
  /**
   *
   * @param {String} beCheckIp
   * @param {String} ip
   * @param {String} mask
   */
  if (mask === "255.255.255.255") {
    return true;
  }
  const sub = utils.getSubnet(ip, mask);
  const broad = utils.getBroadcase(ip, mask);
  if (beCheckIp === sub || beCheckIp === broad) {
    return false;
  }
  return true;
};

utils.checkMac = (mac) => {
  /**
   * Check MAC Address
   * Bellow is invalid
   * 1x:xx:xx:xx
   * @param {String} mac
   */
  if (!utils.checkValidation("mac", mac, false)) {
    log(`Invalid mac for ${mac}`);
    return false;
  }
  const upper = _.toUpper(mac);
  const SecondCharNum = parseInt(mac.charAt(1), 16);
  if (SecondCharNum % 2 === 1) {
    log(`MAC first Char is invalid: ${upper}`);
    return false;
  }
  if (upper === "00:00:00:00:00:00" || upper === "FF:FF:FF:FF:FF:FF") {
    return false;
  }
  return true;
};

utils.formatMac = (originMac) => {
  const result = [];
  for (let i = 0; i < originMac.length && i < 12; i++) {
    if (i != 0 && i % 2 == 0) {
      result.push(":");
    }
    result.push(originMac.charAt(i));
  }
  return result.join("");
};

utils.checkNumRange = (value, min, max) => {
  /**
   *
   * @param {String/Number} value
   * @param {Number} min
   * @param {Number} max
   */
  let num = value;
  log("checkNumRange", num, typeof num);
  if (typeof num === "undefined") {
    return false;
  }
  if (typeof num === "string") {
    if (/^[1-9][0-9]+$/.test(value) || /^[0-9]$/.test(value)) {
      num = parseInt(value, 10);
    } else {
      return false;
    }
  }
  return num >= min && num <= max;
};

utils.dniEncrypt = (value) => {
  /**
   * DNI Encrypt
   * 1. base64 `value`
   * 2. Add Random character before first character
   * 3. Add Random character after last character
   * @param {String} value
   */
  const characters = "1234567890abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ=";
  const result = Base64.encode(value);
  const firstChar = characters[_.random(0, characters.length - 1)];
  const lastChar = characters[_.random(0, characters.length - 1)];
  return Base64.encode(firstChar + result + lastChar);
};
utils.checkIPv6OrDomain = (value) => {
  let host = value;
  if (_.startsWith(value, "http://")) {
    host = value.slice(7);
  } else if (_.startsWith(value, "https://")) {
    host = value.slice(8);
  }
  host = host.split("/")[0];
  if (
    utils.checkValidation("ipv6", host, false) ||
    utils.checkValidation("aftrDomain", host, false)
  ) {
    return true;
  }
  return false;
};
utils.checkIPv4OrDomain = (value) => {
  let host = value;
  if (_.startsWith(value, "http://")) {
    host = value.slice(7);
  } else if (_.startsWith(value, "https://")) {
    host = value.slice(8);
  }
  host = host.split("/")[0];
  if (
    utils.checkValidation("ipv4", host, false) ||
    utils.checkValidation("aftrDomain", host, false)
  ) {
    return true;
  }
  return false;
};
utils.toAtleast2Number = (value) => {
  let target = value;
  if (typeof value !== "number") {
    target = parseInt(value, 10);
  }
  if (target < 0) {
    return value;
  }
  if (target < 10) {
    return "0" + target;
  }
  return target;
};
utils.secToTime = (value) => {
  let origin = value;
  let day = "00";
  let hour = "00";
  let min = "00";
  let sec = "00";
  if (typeof sec !== "number") {
    origin = parseInt(value, 10);
  }
  if (origin <= 0) {
    return "00:00:00";
  }
  day = utils.toAtleast2Number(_.floor(origin / 86400));
  hour = utils.toAtleast2Number(_.floor((origin % 86400) / 3600));
  min = utils.toAtleast2Number(_.floor((origin % 3600) / 60));
  sec = utils.toAtleast2Number(origin % 60);
  if (day !== "00") {
    return day + ":" + hour + ":" + min + ":" + sec;
  }
  return hour + ":" + min + ":" + sec;
};
utils.getAutoMask = (ip) => {
  /**
   * According to IP to calculate netmask automaticly.
   */
  if (!utils.checkIp(ip)) {
    return "";
  }
  const ip1 = parseInt(ip.split(".")[0], 10);
  let mask = "";
  if (ip1 < 128) {
    mask = "255.0.0.0";
  } else if (ip1 < 192) {
    mask = "255.255.0.0";
  } else {
    mask = "255.255.255.0";
  }
  return mask;
};

utils.invalidIpMaskGtw = (ip, netmask, gateway) => {
  /**
   * Check IP，Subnet Mask and Gateway, if invalid it will return error message
   * Otherwise return null;
   * @return errMsg/null;
   */
  if (!utils.checkValidation("netmask1", netmask, false)) {
    return "invalid_mask";
  }
  if (ip === "" || !utils.checkIp(ip)) {
    return "invalid_ip";
  }
  if (gateway === "" || !utils.checkGateway(gateway)) {
    return "invalid_gateway";
  }
  if (!utils.isSubOrBroad(ip, ip, netmask)) {
    return "invalid_ip";
  }
  if (!utils.isSubOrBroad(gateway, gateway, netmask)) {
    return "invalid_gateway";
  }
  if (ip === gateway) {
    return "invalid_gateway";
  }
  return null;
};

utils.checkAccount = (newPassword, confirmPassword, question1, answer1, question2, answer2) => {
  /**
   * Check Account form validation, if invalid it will return error message.
   * @return errMsg/null;
   */
  if (newPassword == "") {
    return "password_null";
  }
  if (newPassword == "password") {
    return "must_change_passwd";
  }
  if (newPassword.length < 8) {
    return "invalid_passwd_length";
  }
  if (!utils.checkValidation("printableAndSpace", newPassword, false)) {
    return "password_error";
  }
  if (newPassword.length > 32) {
    return "max_pwd_len";
  }
  if (newPassword != confirmPassword) {
    return "pwd_no_match";
  }
  if (question1 == "" || question2 == "") {
    return "select_quest";
  }
  if (answer1 == "" || answer2 == "") {
    return "enter_answer";
  }
  if (
    answer1.length > 64 ||
    answer2.length > 64 ||
    !utils.checkValidation("printableAndSpace", answer1, false) ||
    !utils.checkValidation("printableAndSpace", answer2, false)
  ) {
    return "invalid_answer";
  }
  return null;
};

utils.checkSsid = (ssid) => {
  /**
   * Check SSID
   * @return errMsg/null;
   */
  if (ssid == "") {
    return "ssid_null";
  }
  if (!utils.checkValidation("ssid", ssid, false)) {
    return "ssid_not_allowed";
  }
  return null;
};

utils.checkPsk = (password) => {
  /**
   * Check Wireless Password
   * @return errMsg/null;
   */
  if (!utils.checkValidation("passpharse", password, false)) {
    return "notallowpassps";
  }
  return null;
};

utils.checkFileSize = (maxStr, fileSize) => {
  const maxValue = parseInt(maxStr, 10);
  const unit = maxStr.match(/[KkMmBb]/g)[0];
  log("checkFileSize", maxValue, unit);
  let maxSize = 0;
  switch (unit) {
    case "K":
    case "k":
      maxSize = maxValue * 1024;
      break;
    case "M":
    case "m":
      maxSize = maxValue * 1024 * 1024;
      break;
    default:
      maxSize = maxValue;
      break;
  }
  log("checkFileSize", maxSize, fileSize);
  return maxSize >= fileSize;
};

utils.getChangedDomain = (key) => {
  const proto = window.location.protocol;
  const host = window.location.hostname;
  const port = window.location.port;
  let next = host;
  if (host == `${key}.net`) {
    next = `${key}.com`;
  } else if (host == `${key}.com`) {
    next = `www.${key}.net`;
  } else if (host == `www.${key}.net`) {
    next = `www.${key}.com`;
  } else {
    next = `${key}.com`;
  }
  log("getChangedDomain", `${proto}//${next}:${port}`);
  if (port == 80) {
    return `${proto}//${next}`;
  } else {
    return `${proto}//${next}:${port}`;
  }
};

utils.changeDomain = () => {
  let nextDomain = "/";
  if (defaultSettings.type == "orbi") {
    nextDomain = utils.getChangedDomain("orbilogin");
  } else {
    nextDomain = utils.getChangedDomain("routerlogin");
  }
  top.window.location.href = nextDomain;
};

utils.changeUrl = (url) => {
  const proto = window.location.protocol;
  const port = window.location.port;
  let next = `${proto}//${url}:${port}`;
  top.window.location.href = next;
};

utils.getCurrentHost = () => {
  const proto = window.location.protocol;
  const host = window.location.hostname;
  const port = window.location.port;
  return `${proto}//${host}:${port}`;
};

utils.isDutConnected = async () => {
  const ret = await http.get("/info");
  return ret ? true : false;
};

utils.redirectToStart = async () => {
  utils.changeDomain();
};

utils.sleep = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

utils.getDisabledIpNum = (mask) => {
  /**
   * Calculate the disable IPv4 part according to mask.
   * For example, if mask is "255.255.0.0", need to disabled the first 2 box
   */
  if (typeof mask != "string") {
    return 3;
  }
  const arr = mask.split(".");
  let result = 0;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] == "255") {
      result++;
    } else {
      break;
    }
  }
  log("getDisabledIpNum", result);
  return result;
};

utils.getStaticPresetIP = (ip, mask) => {
  /**
   * 根据IP，Mask获取默认前几位
   * 根据目前页面的引用， 统一获取前三位。
   */
  if (typeof ip != "string" || typeof mask != "string") {
    return "";
  }
  const ipArr = ip.split(".");
  const maskArr = mask.split(".");
  if (ipArr.length == 4 && maskArr.length == 4) {
    ipArr[3] = "";
    return ipArr.join(".");
  }
  return "";
};

utils.langMapping = () => {
  return utils.getOptions("lang", "lang");
};

utils.getBrowserLang = () => {
  const naviLang = (navigator.language || navigator.browserLanguage).toLowerCase().split(";");
  let lang = "English";
  let find = false;
  for (let i = 0; i < naviLang.length; i++) {
    find = utils.langMapping().find((o) => {
      return naviLang[i] == o.browser;
    });
    if (find) {
      lang = find.value;
      break;
    }
  }
  if (!find) {
    for (let i = 0; i < naviLang.length; i++) {
      find = utils.langMapping().find((o) => {
        return naviLang[i].includes(o.browser);
      });
      if (find) {
        lang = find.value;
        break;
      }
    }
  }
  return lang;
};

utils.getLanguageShow = (value) => {
  log("getLanguageShow", value);
  const target = value == "Auto" ? utils.getBrowserLang() : value;
  const find = utils.langMapping().filter((o) => {
    return o.value == target;
  });
  if (find && find.length) {
    return find[0].label;
  }
  return "English";
};

utils.routerReplace = (path) => {
  log("[routerReplace] current", router.history.current.fullPath, "=>", path);
  if (router.history.current.fullPath !== path) {
    router.replace({ path });
  } else if (path != "/login") {
    window.location.reload();
  }
};

utils.routerReplace2 = (name, redirect) => {
  const whiteList = ["unauth", "login", "multi", "multiGuest", "token"];
  console.log("[routerReplace2] current", router.history.current.name, "=>", name);
  if (router.history.current.name !== name) {
    if (whiteList.includes(redirect)) {
      router.replace({ name });
    } else {
      if (redirect == "debug") {
        redirect = "debug.htm";
      }
      router.replace({ name, params: { redirect } });
    }
  } else if (name != "login") {
    window.location.reload();
  }
};

utils.routerPush = (path) => {
  log("[routerPush] current", router.history.current.fullPath, "=>", path);
  if (router.history.current.fullPath !== path) {
    router.push({ path });
  } else if (path != "/login") {
    window.location.reload();
  }
};

utils.reloadPageAfterReboot = () => {
  top.window.location.href = "/";
  setTimeout(function () {
    top.window.location.reload();
  }, 1000);
};

utils.getPcTz = (list) => {
  const d = new Date();
  const isSupportDst = () => {
    const d1 = new Date(d.getFullYear(), 0, 1);
    const d2 = new Date(d.getFullYear(), 6, 1);
    return d1.getTimezoneOffset() !== d2.getTimezoneOffset();
  };
  const offsetToGmt = (offset) => {
    let keyword = "GMT";
    let offsetNum = Math.abs(offset);
    if (offset <= 0) {
      keyword += "+";
      offsetNum = 0 - offset;
    } else {
      keyword += "-";
    }
    const hour = Math.floor(offsetNum / 60);
    const min = offsetNum % 60;
    log(offsetNum, hour, min);
    keyword += hour > 9 ? hour + "" : "0" + hour;
    keyword += ":";
    keyword += min > 9 ? min + "" : "0" + min;
    return keyword;
  };
  const getMonthWeek = () => {
    let day = d.getDay();
    const date = d.getDate();
    return Math.ceil((date + 6 - day) / 7);
  };
  const getTotalMonthWeek = (month) => {
    const d1 = new Date(d.getFullYear(), month, 1);
    const firstWeekDate = d1.getDay();
    d1.setDate(0);
    return Math.ceil((d1.getDay() + firstWeekDate) / 7);
  };
  const adjustDst = (offset, dst) => {
    const minMon = parseInt(
      dst
        .split("-")[0]
        .split("M")[1]
        .split(".")[0],
      10,
    );
    let minWeek = parseInt(
      dst
        .split("-")[0]
        .split("M")[1]
        .split(".")[1],
      10,
    );
    const minDay = parseInt(
      dst
        .split("-")[0]
        .split("M")[1]
        .split(".")[2],
      10,
    );
    const maxMon = parseInt(
      dst
        .split("-")[1]
        .split("M")[1]
        .split(".")[0],
      10,
    );
    let maxWeek = parseInt(
      dst
        .split("-")[1]
        .split("M")[1]
        .split(".")[1],
      10,
    );
    const maxDay = parseInt(
      dst
        .split("-")[1]
        .split("M")[1]
        .split(".")[2],
      10,
    );
    const curMon = d.getMonth();
    const curWeek = getMonthWeek();
    const curDay = d.getDay();
    minWeek = minWeek === 5 ? getTotalMonthWeek(minMon) : minWeek;
    maxWeek = maxWeek === 5 ? getTotalMonthWeek(maxMon) : maxWeek;
    if (minMon < maxMon) {
      if (
        (curMon > minMon && curMon < maxMon) ||
        (curMon == minMon &&
          (curWeek > minWeek ||
            (curWeek == minWeek && curDay > minDay) ||
            (curWeek == minWeek && curDay == minDay && d.getHours() >= 2))) ||
        (curMon == maxMon &&
          (curWeek < maxWeek ||
            (curWeek == maxWeek && curDay < maxDay) ||
            (curWeek == maxWeek && curDay == maxDay && d.getHours() < 2)))
      ) {
        log(dst);
        return offset + 60;
      }
    } else if (minMon > maxMon) {
      if (
        curMon > minMon ||
        curMon < maxMon ||
        (curMon == minMon &&
          (curWeek > minWeek ||
            (curWeek == minWeek && curDay > minDay) ||
            (curWeek && curDay == minDay && d.getHours() >= 2))) ||
        (curMon == maxMon &&
          (curWeek < maxWeek ||
            (curWeek == maxWeek && curDay < maxDay) ||
            (curWeek == maxWeek && curDay == maxDay && d.getHours() < 2)))
      ) {
        log(dst);
        return offset + 60;
      }
    }
    return offset;
  };
  let offset = d.getTimezoneOffset();
  log("current offset", offset);
  if (isSupportDst()) {
    if (offset >= 150 && offset <= 600) {
      offset = adjustDst(offset, "M3.2.0-M11.1.0");
    } else if (offset >= -180 && offset <= 120) {
      offset = adjustDst(offset, "M4.1.0-M10.5.0");
    } else if (offset >= -840 && offset <= -600) {
      offset = adjustDst(offset, "M10.5.0-M3.5.0");
    }
  }
  for (let i = 0; i < 6; i++) {
    const keyword = offsetToGmt(offset);
    log("current offset", offset, "keyword", keyword);
    const find = list.find((o) => {
      return o.timezone_keyword.includes(keyword);
    });
    if (find) {
      log("current timezone", find.timezone_keyword);
      return find.timezone_keyword;
    } else {
      offset += 15;
    }
  }
  return null;
};

utils.datetimeFormat = (datetime) => {
  const changeFullWeek = (week) => {
    let showWeek = "";
    if (week == "Monday") {
      showWeek = i18n.t("schedule_mon");
    } else if (week == "Tuesday") {
      showWeek = i18n.t("schedule_tue");
    } else if (week == "Wednesday") {
      showWeek = i18n.t("schedule_wed");
    } else if (week == "Thursday") {
      showWeek = i18n.t("schedule_thu");
    } else if (week == "Friday") {
      showWeek = i18n.t("schedule_fri");
    } else if (week == "Saturday") {
      showWeek = i18n.t("schedule_sat");
    } else if (week == "Sunday") {
      showWeek = i18n.t("schedule_sun");
    } else {
      showWeek = week;
    }

    return showWeek;
  };
  const changeMonth = (month) => {
    let showMonth;
    if (month == "Jan") {
      showMonth = i18n.t("January");
    } else if (month == "Feb") {
      showMonth = i18n.t("February");
    } else if (month == "Mar") {
      showMonth = i18n.t("March");
    } else if (month == "Apr") {
      showMonth = i18n.t("April");
    } else if (month == "May") {
      showMonth = i18n.t("May");
    } else if (month == "Jun") {
      showMonth = i18n.t("June");
    } else if (month == "Jul") {
      showMonth = i18n.t("July");
    } else if (month == "Aug") {
      showMonth = i18n.t("August");
    } else if (month == "Sep") {
      showMonth = i18n.t("September");
    } else if (month == "Oct") {
      showMonth = i18n.t("October");
    } else if (month == "Nov") {
      showMonth = i18n.t("November");
    } else if (month == "Dec") {
      showMonth = i18n.t("December");
    } else {
      showMonth = month;
    }
    return showMonth;
  };
  const eachStr = (datetime || "").split(", ");

  const week = eachStr[0];
  const showWeek = changeFullWeek(week);

  const date_info = (eachStr[1] || "").split(" ");
  const month = date_info[0];
  const showMonth = changeMonth(month);
  const day = date_info[1];

  const time = eachStr[2];
  let newStr = "";
  const gui_region = store.state.user.gui_region;
  if (gui_region == "German") {
    newStr = showWeek + ", " + day + "." + showMonth + ", " + time;
  } else if (gui_region == "French") {
    newStr = showWeek + ", " + day + " " + showMonth + " " + time;
  } else {
    newStr = showWeek + ", " + showMonth + " " + day + ", " + time;
  }

  return newStr;
};

utils.sortObjectByKey = (obj, key) => {
  const compare = (keyStr) => {
    return (obj1, obj2) => {
      const a = obj1[keyStr];
      const b = obj2[keyStr];
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    };
  };
  return obj.sort(compare(key));
};

utils.compare_2_ip = (from, to) => {
  /**
   * true invalid from and to ip;  false valid from and to ip;
   * @param {String} from
   * @param {String} to
   */
  var total1 = 0;
  var total2 = 0;
  var from_array = (from || "").split(".");
  var to_array = (to || "").split(".");
  var from1 = from_array[0];
  var to1 = to_array[0];
  if (parseInt(from1, 10) <= 127 && parseInt(to1, 10) >= 127) {
    return false;
  }
  var from2 = from_array[1];
  var from3 = from_array[2];
  var from4 = from_array[3];
  var to2 = to_array[1];
  var to3 = to_array[2];
  var to4 = to_array[3];

  total1 += parseInt(from4, 10);
  total1 += parseInt(from3, 10) * 256;
  total1 += parseInt(from2, 10) * 256 * 256;
  total1 += parseInt(from1, 10) * 256 * 256 * 256;

  total2 += parseInt(to4, 10);
  total2 += parseInt(to3, 10) * 256;
  total2 += parseInt(to2, 10) * 256 * 256;
  total2 += parseInt(to1, 10) * 256 * 256 * 256;
  if (total1 <= total2) {
    return true;
  }
  return false;
};

utils.checkPpIp = (ip) => {
  /**
   * Check the validation for WAN IP
   *  * Bellow is invalid
   *  * ip1 > 223
   *  * ip1 == 0
   *  * 0.0.0.0, 255.255.255.255
   *  * 127.*.*.*
   * @param {String} ip
   */
  if (!utils.checkValidation("ipv4", ip, false)) {
    return false;
  }
  if (ip === "0.0.0.0" || ip === "255.255.255.255") {
    return false;
  }
  const ip1 = parseInt(ip.split(".")[0], 10);
  if (ip1 === 0 || ip1 === 127 || ip1 > 223) {
    return false;
  }
  const ip4 = parseInt(ip.split(".")[3], 10);
  if (!(ip4 > 0 && ip4 < 255)) {
    return false;
  }
  return true;
};

utils.getDeviceRefreshInterval = (num) => {
  if (num == 1) {
    return 1000;
  } else {
    return (num - 1) * 2000;
  }
};

utils.getIds = (page, name) => {
  if (!ids[page]) {
    log("getIds", `Cannot find ids.${page}`);
    return name;
  }
  if (!ids[page][name]) {
    log("getIds", `Cannot find ${name} in ids.${page}`);
    return name;
  }
  return ids[page][name];
};

utils.getConnectTypeString = (conn_type) => {
  if (conn_type == "wired") {
    return i18n.t("acc_wired");
  } else if (conn_type == "main_2g") {
    return "2.4G";
  } else if (conn_type == "main_5g") {
    return "5G";
  } else if (conn_type == "guest_2g") {
    return "2.4G Guest";
  } else if (conn_type == "guest_5g") {
    return "5G Guest";
  } else if (conn_type == "wireless1_2g") {
    return "2.4G Wireless1";
  } else if (conn_type == "wireless1_5g") {
    return "5G Wireless1";
  } else if (conn_type == "wireless1_5g2") {
    return "5G High Wireless1";
  } else if (conn_type == "guest_portal_2g") {
    return "2.4G Guest Portal";
  } else if (conn_type == "guest_portal_5g") {
    return "5G Guest Portal";
  } else if (conn_type == "guest_portal_5g2") {
    return "5G High Guest Portal";
  } else if (conn_type == "wireless2_2g") {
    return "2.4G Wireless2";
  } else if (conn_type == "wireless2_5g") {
    return "5G Wireless2";
  } else if (conn_type == "wireless2_5g2") {
    return "5G High Wireless2";
  } else if (conn_type == "wireless3_2g") {
    return "2.4G Wireless3";
  } else if (conn_type == "wireless3_5g") {
    return "5G Wireless3";
  } else if (conn_type == "wireless3_5g2") {
    return "5G High Wireless3";
  } else if (conn_type == "unknown") {
    return i18n.t("unknown_mark");
  } else {
    return conn_type;
  }
};

utils.getAccessStatusString = (acc_status) => {
  if (acc_status == "block") return i18n.t("acc_block");
  else return i18n.t("acc_allow");
};

utils.getLinkStatusString = (rssi) => {
  let status = i18n.t("state_very_poor");
  if (rssi < -80) {
    status = i18n.t("state_poor");
  } else if (rssi < -60) {
    status = i18n.t("state_fair");
  } else if (rssi < -30) {
    status = i18n.t("state_good");
  } else if (rssi >= -30) {
    status = i18n.t("state_excellent");
  }
  return status;
};

utils.cloneObject = (obj) => {
  if (typeof obj == "undefined") {
    return {};
  }
  return JSON.parse(JSON.stringify(obj));
};

utils.checkIpWithMultiLan = (ip, lans) => {
  var error_code = "NO_ERROR";
  error_code = !utils.checkIp(ip) ? "INVALID_IP" : error_code;
  Object.keys(lans).forEach((o) => {
    if (error_code != "NO_ERROR") return error_code;
    if (o.includes("lan")) {
      const item = lans[o];
      if (item.enable == undefined || item.enable == "1") {
        error_code = ip === item.ip_addr ? "SAME_LANIP" : error_code;
        error_code = !utils.isSubOrBroad(
          ip,
          item.ip_addr,
          item.ip_mask,
        )
          ? "INVALID_IP"
          : error_code;
      }
    }
  });
  return error_code;
};

utils.checkSubnetWithMultiLan = (ip, lans) => {
  var result = false;
  Object.keys(lans).forEach((o) => {
    if (o.includes("lan")) {
      const item = lans[o];
      if (item.enable == undefined || item.enable == "1") {
        result =
          result ||
          utils.isSameSubnet(
            ip,
            item.ip_mask,
            item.ip_addr,
            item.ip_mask,
          );
      }
    }
  });
  return result;
};

Vue.prototype.utils = utils;

export default utils;
